import UiHelper from './UiHelper';

class ExpandBlockFactory
{
    static init()
    {
        Array.from(UiHelper.getNodes('.js-expand-block')).forEach(expandBlock =>
        {
            new ExpandBlock(expandBlock);
        });
    }
}
export default ExpandBlockFactory;


export class ExpandBlock
{
    constructor(wrap)
    {
        this.wrap = wrap;
        this.toggle = this.wrap.querySelector('.js-expand-block__toggle');
        this.contentWrap = this.wrap.querySelector('.js-expand-block__content-wrap');
        this.elementPosition = this.toggle.getBoundingClientRect().top;
        this.offsetPosition = this.elementPosition - 125;
        this.expanded = false;
        if(this.wrap.classList.contains('expand-block--expanded')) this.expanded = true;

        this.transitionEnd = this.transitionEnd.bind(this);

        if(this.toggle.hash === location.hash) {
            setTimeout(() =>
            {
                window.scrollTo({
                    top: this.offsetPosition,
                    behavior: "smooth"
                });
                this.expand();
            }, 200);
        }

        this.toggle.addEventListener('click', e =>
        {
            if (this.expanded) this.collapse();
            else this.expand();
        });

        this.contentWrap.addEventListener("transitionend", this.transitionEnd);
    }

    expand()
    {
        this.contentWrap.classList.add('expand-block__content-wrap--measure');
        const contentHeight = this.contentWrap.offsetHeight;
        this.contentWrap.classList.remove('expand-block__content-wrap--measure');

        setTimeout(() =>
        {
            this.contentWrap.style.height = contentHeight + 'px';
        }, 10);

        this.wrap.classList.add('expand-block--expanded');
        this.expanded = true;
    }

    collapse()
    {
        this.contentWrap.style.height = this.contentWrap.offsetHeight + 'px';

        setTimeout(() =>
        {
            this.contentWrap.style.height = '0px';
        }, 10);

        this.wrap.classList.remove('expand-block--expanded');
        this.expanded = false;
    }

    transitionEnd(e)
    {
        this.contentWrap.style.height = this.expanded ? 'auto' : null;
    }

}
